// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zHn2","comment":"styles_comment__2Gg1L"};